/* tslint:disable */
/* eslint-disable */
/**
 * Billaan API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubmitApplicationRequest
 */
export interface SubmitApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof SubmitApplicationRequest
     */
    applicationId?: string;
}

/**
 * Check if a given object implements the SubmitApplicationRequest interface.
 */
export function instanceOfSubmitApplicationRequest(value: object): value is SubmitApplicationRequest {
    return true;
}

export function SubmitApplicationRequestFromJSON(json: any): SubmitApplicationRequest {
    return SubmitApplicationRequestFromJSONTyped(json, false);
}

export function SubmitApplicationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitApplicationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationId': json['applicationId'] == null ? undefined : json['applicationId'],
    };
}

export function SubmitApplicationRequestToJSON(json: any): SubmitApplicationRequest {
    return SubmitApplicationRequestToJSONTyped(json, false);
}

export function SubmitApplicationRequestToJSONTyped(value?: SubmitApplicationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationId': value['applicationId'],
    };
}

